import { render, staticRenderFns } from "./ProductModelEditor.vue?vue&type=template&id=3c354978&scoped=true"
import script from "./ProductModelEditor.vue?vue&type=script&lang=js"
export * from "./ProductModelEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c354978",
  null
  
)

export default component.exports